import React, { useEffect, useState } from 'react';
import { ShotBatch, validateShotBatch } from '../shotBatch';
import { videoEmbedUrl } from '../../squads/classroom/aiCreation';
import { optionLabel } from '../../squads/classroom/aiGroups';
import './shotBatchExample.css';

export default function ShotBatchExample({ url }: { url: string }) {
  const [batch, setBatch] = useState<ShotBatch | null>(null);
  const [error, setError] = useState('');
  const [shotIndex, setShotIndex] = useState(0);
  const [optionIndex, setOptionIndex] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setBatch(null); setError(''); setShotIndex(0); setOptionIndex(0);
    void fetch(url, { signal: controller.signal }).then(response => {
      if (!response.ok) throw new Error('Could not load the shot batch.');
      return response.json();
    }).then(data => { if (!controller.signal.aborted) setBatch(validateShotBatch(data)); })
      .catch(() => { if (!controller.signal.aborted) setError('Could not load the shot batch. Close and reopen the preview to try again.'); });
    return () => controller.abort();
  }, [url]);
  const shot = batch?.shots[shotIndex];
  const option = shot?.options[optionIndex];
  if (!batch || !shot || !option) return <div className="shot-batch-example" role="status">{error || 'Loading shot batch…'}</div>;
  const embed = option.type === 'link' ? videoEmbedUrl(option.source) : null;
  return <div className="shot-batch-example">
    <strong>Our Rough Cut: Shot Selection</strong>
    <nav aria-label="Example shots">{batch.shots.map((item, index) => <button type="button" key={index} aria-pressed={index === shotIndex} onClick={() => { setShotIndex(index); setOptionIndex(0); }}>{index + 1}. {item.title}</button>)}</nav>
    <div className="shot-batch-example-options"><strong>{shot.title}</strong>{shot.options.map((item, index) => <button key={index} type="button" aria-pressed={index === optionIndex} onClick={() => setOptionIndex(index)}>Option {optionLabel(index)}</button>)}</div>
    <div className="shot-batch-example-media" key={`${shotIndex}-${optionIndex}`}>
      {option.type === 'video' ? <video src={option.source} controls playsInline preload="metadata" />
        : option.type === 'image' ? <img src={option.source} alt={option.caption || shot.title} />
        : embed ? <iframe src={embed} title={option.caption || shot.title} allow="autoplay; encrypted-media" allowFullScreen />
        : <a href={option.source} target="_blank" rel="noreferrer">Open option {optionLabel(optionIndex)} ↗</a>}
    </div>
    {option.caption && <p>{option.caption}</p>}
    <small>Shot {shotIndex + 1} of {batch.shots.length} · {shot.options.length} {shot.options.length === 1 ? 'option' : 'options'}</small>
  </div>;
}
